import { Component, OnInit } from '@angular/core';
import { FormGroup} from "@angular/forms";
import { UserService, AutoCompleteService } from '../../_services';
import {  AssignUserOnBehalf, AddUser, LoginUser } from '../../_models';
import { ConfirmationDialogService } from '../../_services/confirmation-dialog.service';
import { GlobalDataService } from '../../_shared';

import { Observable, Subject } from 'rxjs';
import {
  map,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap
} from "rxjs/operators";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPopupAlertComponent } from '../../_shared/modal-popup-alert/modal-popup-alert.component';
import { environment } from '../../../environments/environment';
import { AdminService } from '../../_services/admin.service';
@Component({
  standalone: false,
  selector: 'app-assign-user-on-behalf',
  templateUrl: './assign-user-on-behalf.component.html',
  styleUrls: ['./assign-user-on-behalf.component.css']
})
export class AssignUserOnBehalfComponent implements OnInit {
  assignUserForm!: FormGroup;
  user!: LoginUser;
  assignUsers!: AssignUserOnBehalf[];
assignUserOnBehalf = new AssignUserOnBehalf();
assignformlabel: string = '';  

//Auto complete declartion
 results!: Observable<AddUser[]>;  
private searchTerms = new Subject<string>();  
 resultsProvisioningID!: Observable<AddUser[]>;  
private searchTermsProvisioningID = new Subject<string>();  
 BehalfName = '';  
 BehalfProvisioningID = '';  
 loading: boolean = true;
config: any;
FrmDt : any ;
ToDt: any ;
minDate: any;
minToDate: any;
  viewUsers!: AddUser[];
  arrayList!: Array<string>;


  constructor
  (
    private userService : UserService,
    private confirmationDialogService: ConfirmationDialogService,
    private gd : GlobalDataService,
    private autoCompleteService  : AutoCompleteService,
    private modalService: NgbModal,
    private adminService  : AdminService
    ) { }

  ngOnInit() {
    this.user = this.gd.getUserData();
    this.getAllUsers();
    this.getAllAssignedUsers();
    this.initForm();
    this.minDate = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate()
    }

    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: 0
    };
   
    };  
  PrepareData(){
 //prepare json data
    
 this.assignUserOnBehalf.BehalfCAI = this.BehalfProvisioningID;
 this.assignUserOnBehalf.BehalfName = this.BehalfName;
 this.assignUserOnBehalf.IsActive = true;
 this.assignUserOnBehalf.CreatedBy =this.user.ProvisioningID;
 this.assignUserOnBehalf.CreatedDate = new Date();
 this.assignUserOnBehalf.FromDate = this.gd.convertToStandardDate(  this.FrmDt ) ;
 this.assignUserOnBehalf.ToDate = this.gd.convertToStandardDate(  this.ToDt) ;
 
  }
  OnSubmit(){

   
    this.PrepareData();
    this.userService.assignUser(this.assignUserOnBehalf).subscribe(data=>{
      this.getAllAssignedUsers();
      this.initForm();
      this.openAlertModal("Record Saved Successfully")
    },
    error=>{
     
    }
    );
  }

  onBlurMethod()
  {
    this.minToDate = {
      year:new Date(this.gd.convertToStandardDate(  this.FrmDt )).getFullYear() ,
      month: new Date(this.gd.convertToStandardDate(  this.FrmDt )).getMonth() + 1,
      day: new Date(this.gd.convertToStandardDate(  this.FrmDt )).getDate()
    }
  }
  
  openAlertModal(strmsg: any) {
    const modalRef = this.modalService.open(ModalPopupAlertComponent);
    modalRef.componentInstance.strText = strmsg;
    modalRef.result.then((result) => {
    }, (reason) => {
    });   
  }

   deleteConfirm(deleteUser : AssignUserOnBehalf) {
    this.confirmationDialogService.confirm('Please confirm..', 'Do you really want to Delete. ?')
    .then((confirmed) => {if(confirmed==true){this.deleteAssignedUser(deleteUser)}})
    .catch(() => {});
  }
  deleteAssignedUser(assignUser : AssignUserOnBehalf) {
    assignUser.IsActive=false;
    this.userService.deleteAssignUser(assignUser).subscribe(res => {
      this.getAllAssignedUsers();
    });
  }
  getAllAssignedUsers()
  {
    this.userService.viewAssignUser(this.user.ProvisioningID).subscribe(data=>{
      this.assignUsers = data;
      this.config = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.assignUsers.length
      };
    });
  }
  initForm()
  {
   
  }

  initalCallService(){
    
    this.autoCompleteService.endPoint= environment.ApiUrl + "user/getuserlist/term";
    this.results = this.searchTerms.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(_ => (this.loading = true)),
      switchMap(term => this.autoCompleteService.search(term))
    );
    
    this.autoCompleteService.endPoint= environment.ApiUrl + "user/getappusercailist/term";
    this.resultsProvisioningID = this.searchTermsProvisioningID.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(_ => (this.loading = true)),
      switchMap(term => this.autoCompleteService.search(term))
    );
  }
  
  
   
  getAllUsers()
  {
    this.adminService.viewUsers().subscribe(data=>{
      this.viewUsers = data;
      this.arrayList = data.map(user => user.ProvisioningID?.trim()); 
    });
  }

  searchUserProvisioningID = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.arrayList.filter(v => v?.toLowerCase().indexOf(term?.toLowerCase()) > -1).slice(0, 10))
  )

  selectedItem(item: any){
    this.BehalfName=this.viewUsers.filter(t=>t.ProvisioningID ==item.item)[0].Name;
    this.loading = false;  
  }

  pageChanged(event: any){
    this.config.currentPage = event;
  }

}
